import React, { FC, useEffect } from "react";

import { getBySelector, getBySelectorRegExp } from "../../../utils/dom";

type Props = {
  targetSelector: string;
  callback: (el: HTMLElement) => void;
  rootElement?: HTMLElement;
  lookSubtree?: boolean;
  disabled?: boolean;
  useRegExpToSelect?: boolean;
};

export const ElementObserver: FC<Props> = ({
  targetSelector,
  callback,
  rootElement = document.body,
  lookSubtree = false,
  disabled = false,
  useRegExpToSelect = false,
}) => {
  useEffect(() => {
    const observerCallback: MutationCallback = (mutationsList, observer) => {
      for (const mutation of mutationsList) {
        if (mutation.type === "childList") {
          const targetElement = useRegExpToSelect
            ? getBySelectorRegExp(targetSelector)
            : getBySelector(targetSelector);

          if (targetElement) {
            callback(targetElement);
            observer.disconnect();
            break;
          }
        }
      }
    };

    const observer = new MutationObserver(observerCallback);

    if (!disabled) {
      observer.observe(rootElement, { childList: true, subtree: lookSubtree });
    }

    return () => {
      observer.disconnect();
    };
  }, [
    targetSelector,
    rootElement,
    lookSubtree,
    callback,
    disabled,
    useRegExpToSelect,
  ]);

  return <></>;
};
